import PropTypes from 'prop-types';
import React from 'react';

import { useAuth } from '../../lib/authContext';
import ConfirmationModal from '../sections/provisional-offer-options/ConfirmationModal';

const SignOutModal = ({ visible, closeSignOutModal }) => {
  const { handleLogout } = useAuth();
  const signOutAndHideModal = () => {
    closeSignOutModal();
    handleLogout();
  };

  return (
    <ConfirmationModal
      isOpen={visible}
      title="Do you want to sign out?"
      content="Your progress has been saved. Come back any time to continue."
      confirmText="Sign Out"
      cancelText="Cancel"
      onClose={closeSignOutModal}
      onConfirm={signOutAndHideModal}
    />
  );
};

SignOutModal.propTypes = {
  visible: PropTypes.bool,
  closeSignOutModal: PropTypes.func.isRequired,
};

SignOutModal.defaultProps = {
  visible: false,
};

export default SignOutModal;
